export default __webpack_public_path__ + "static/media/excel.c384ae8b.svg";